import { Button, styled } from '@mui/material'
import React from 'react'

import { StyledLink } from './common'
import { nonAuthNavMap } from './definitions'

type Props = {
  currentPage: string
}

const NonAuthNav: React.FC<Props> = ({ currentPage }) => (
  <NonAuthNavContainer>
    {nonAuthNavMap
      .filter(({ name }) => currentPage !== name)
      .map(({ title, url }) => (
        <StyledLink key={url} to={url}>
          <Button variant="outlined" color="inherit" style={{ borderColor: '#fff' }}>
            {title}
          </Button>
        </StyledLink>
      ))}
  </NonAuthNavContainer>
)

const NonAuthNavContainer = styled('div')({
  display: 'flex',
  textAlign: 'right',
})

export default NonAuthNav
